// REDESIGN 2024

export const navigationElement: HTMLElement | null = document.querySelector('[data-navigation]');

export const dynamicNavigation: HTMLElement | null = document.querySelector(
    '[data-dynamic-navigation]',
);

export const infoStripElement: HTMLElement | null = document.querySelector('[data-info-strip]');

export const breakingNewsElement: HTMLElement | null =
    document.querySelector('[data-breaking-news]');

export const brandingWrapperElement: HTMLElement | null =
    document.querySelector('.branding-wrapper');
